import { render, staticRenderFns } from "./ChevronLeftIcon.vue?vue&type=template&id=56128a48&"
import script from "./ChevronLeftIcon.vue?vue&type=script&lang=ts&"
export * from "./ChevronLeftIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ChevronLeftIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports